import { ArrowDown } from "@repo/icons";
import { cn } from "@repo/lib";
import { CpsSpinner } from "corpus";
import PullToRefresh from "react-simple-pull-to-refresh";

interface PageProps extends React.ComponentPropsWithoutRef<"div"> {
  children: React.ReactNode;
  className?: string;
  onRefresh?: () => Promise<void>;
}

/**
 * Page component that renders page content with standard page styling.
 *
 * @param children - Page component children.
 * @param className -  Page componente className
 * @param onRefresh - Function to call when the page is refreshed and pull to refresh is triggered.
 * @param props - Additional props to pass to the page component.
 * @returns JSX.Element - Rendered Page component.
 */
export const Page = ({
  children,
  className,
  onRefresh,
  ...props
}: PageProps): JSX.Element => {
  if (onRefresh) {
    return (
      <div
        className={cn(
          "flex-1 container m-auto overflow-scroll scrollbar-hidden overscroll-none px-4 pt-4 pb-4",
          className,
        )}
        {...props}
      >
        <PullToRefresh
          onRefresh={onRefresh}
          refreshingContent={
            <div className="py-4">
              <CpsSpinner small />
            </div>
          }
          pullingContent={
            <div className="flex flex-col w-full items-center justify-center gap-2 text-neutral-400">
              Atualizar
              <ArrowDown className="fill-neutral-400" />
            </div>
          }
          pullDownThreshold={95}
          maxPullDownDistance={100}
        >
          {children as JSX.Element}
        </PullToRefresh>
      </div>
    );
  }

  return (
    <div
      className={cn(
        "flex-1 container m-auto overflow-scroll scrollbar-hidden overscroll-none px-4 pt-4 pb-4",
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
};
